var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRollerCoaster({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43 63-.025-9.481h-2l.012 4.481h-12.155l6.886-10.712 4.291 3.433 1.249-1.561-11.45-9.16h9.192a1 1 0 0 0 .817-1.577l-10.887-15.423h10.07a1 1 0 0 0 .817-1.577l-12-17a1.037 1.037 0 0 0 -1.634 0l-12 17a1 1 0 0 0 .817 1.577h10.07l-10.887 15.423a1 1 0 0 0 .817 1.577h9.15l-11.15 8.92v-1.16h-2v2.76l-1.257 1 1.249 1.562.008-.002v9.92h2v-3h13v3h2v-3h12.992l.008 3zm-30-5v-6.52l5.268-4.214 6.9 10.734zm13-2.4-6.162-9.59 6.162-4.93zm0-17.6h-9.07l9.07-12.849zm0-17h-9.07l9.07-12.849zm2-12.849 9.07 12.849h-9.07zm0 17 9.07 12.849h-9.07zm0 15.963 6.148 4.918-6.148 9.568z",
    fill: "#9a9b9f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42.975 53.492-2 .005.012 4.478h-12.155l6.886-10.712 4.291 3.437 1.249-1.561-11.45-9.16h9.192a1 1 0 0 0 .817-1.577l-10.887-15.427h10.07a1 1 0 0 0 .817-1.577l-12-17a.992.992 0 0 0 -.817-.398v58.975h1v-3h12.992l.008 3 2-.005zm-14.975-45.366 9.07 12.849h-9.07zm0 17 9.07 12.849h-9.07zm0 15.963 6.148 4.918-6.148 9.563z",
    fill: "#acadb1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m42 44 .1-.019a6.1 6.1 0 0 0 4.9-5.981 2 2 0 0 1 -2-2 2 2 0 0 1 2-2 2 2 0 0 0 2-2 2 2 0 0 0 -2-2h-5",
    fill: "#f5b94c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m42 30 .1-.019a6.1 6.1 0 0 0 4.9-5.981 2 2 0 0 1 -2-2 2 2 0 0 1 2-2 2 2 0 0 0 2-2 2 2 0 0 0 -2-2h-5",
    fill: "#52a04f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#50bae3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44 13h2v5h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44 9h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 5h2v9h-2z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m5 63 1.281-1.537a37.618 37.618 0 0 0 8.719-24.083v-20.38a12 12 0 0 1 12-12 12 12 0 0 1 12 12v31.757a10.242 10.242 0 0 0 3 7.243 10.242 10.242 0 0 0 7.243 3h13.757v-3h-14.172a6.826 6.826 0 0 1 -4.828-2 6.826 6.826 0 0 1 -2-4.828v-32.172a15 15 0 0 0 -15-15 15 15 0 0 0 -15 15v20.858a34.142 34.142 0 0 1 -10 24.142l-1 1z",
    fill: "#9b2235"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m42.525 56.475a10.23 10.23 0 0 0 6.718 2.525h13.757v-2h-13.172a6.826 6.826 0 0 1 -4.828-2 6.717 6.717 0 0 1 -.473-.527 6.717 6.717 0 0 1 -.527-.473 6.826 6.826 0 0 1 -2-4.828v-32.172a14.926 14.926 0 0 0 -3.917-10.083 14.982 14.982 0 0 0 -25.083 11.083v20.858a34.142 34.142 0 0 1 -10 24.142h2l1.281-1.537a37.618 37.618 0 0 0 8.719-24.083v-20.38a11.988 11.988 0 0 1 20.961-7.961 11.955 11.955 0 0 1 4.039 8.961v31.757a10.23 10.23 0 0 0 2.525 6.718z",
    fill: "#bd2c46"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m48.737 31.026a4.988 4.988 0 0 0 -4.737 4.974v7.247a6.1 6.1 0 0 0 3-5.247 2 2 0 0 1 0-4 2 2 0 0 0 2-2 1.979 1.979 0 0 0 -.263-.974z",
    fill: "#bc9834"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m48.737 17a4.987 4.987 0 0 0 -4.737 4.974v7.247a6.1 6.1 0 0 0 3-5.247 2 2 0 0 1 0-4 2 2 0 0 0 2-2 1.973 1.973 0 0 0 -.263-.974z",
    fill: "#3b7537"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollerCoaster);
export default __webpack_public_path__ + "static/media/roller-coaster.49b69b40afe6c625e6c57e43822fe15f.svg";
export { ForwardRef as ReactComponent };